import { useNavigate } from 'react-router-dom'

import { Button } from '@components/common'
import { Typography } from '@mui/material'
import { PAGE_ROUTES_PUBLIC } from '@appTypes/enums/pages'
import { Section } from './styled'

const Oops = () => {
  const navigate = useNavigate()

  return (
    <Section>
      <Typography component='h1' variant='h1'>
        Oops!
      </Typography>
      <Typography component='p' variant='body1'>
        Something went wrong
      </Typography>
      <Button
        type='button'
        color='primary'
        onClick={() => navigate(PAGE_ROUTES_PUBLIC.SIGN_IN, { replace: true })}
      >
        Log In
      </Button>
    </Section>
  )
}

export default Oops
